import { Button, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as InfoIcon } from 'assets/icons/filled_info.svg';
import { UPGRADE_REDIRECT_BIZ_LINK } from 'constants/links';
import { Mixpanel, UPGRADE } from 'libs/third-party/Mixpanel';
import { getUserPlanProperty } from 'libs/third-party/Mixpanel/mixpanel.helper';
import { UserType } from 'modules/User';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { setAnalyticsUpgradeFeatureProp } from 'utils/sessionStorage';

interface GenerationUpgradeProps {
  userType: UserType;
}

export const GenerationUpgradeBanner = ({ userType }: GenerationUpgradeProps) => {
  const { t } = useTranslation('common_navbar');

  return (
    <Flex flexDir='row' p={2} bg='blackAlpha.200' w='100%' justifyContent={'space-between'} borderRadius={4}>
      <Flex flexDir='row' color={'font.500'} placeItems={'center'}>
        <InfoIcon width={'16'} height={'16'} fill='#55555D' />
        <Text ml={2} fontSize='xs' fontWeight='medium'>
          {t('generationOutOfCreditsText')}
        </Text>
      </Flex>
      <UpgradeButton userType={userType} />
    </Flex>
  );
};

const UpgradeButton = memo(({ userType }: GenerationUpgradeProps): ReactElement | null => {
  const { t } = useTranslation('common_navbar');

  // Redirect to business upgrade
  const onClick = () => {
    Mixpanel.track(UPGRADE, {
      Feature: UPGRADE.feature.DesignAIGeneration,
      'User Plan': getUserPlanProperty(userType),
    });
    setAnalyticsUpgradeFeatureProp(UPGRADE.feature.DesignAIGeneration);
    window.open(UPGRADE_REDIRECT_BIZ_LINK, '_self');
  };

  const testId = 'navbar-upgrade-button';
  const label = 'Upgrade';

  return (
    <Button
      variant='upgrade'
      size='sm'
      height={'28px'}
      fontSize={'xs'}
      data-testid={testId}
      aria-label={label}
      onClick={onClick}
      borderRadius={'base'}
    >
      {t('navbar.upgrade-button')}
    </Button>
  );
});

UpgradeButton.displayName = 'UpgradeButton';
